if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      	const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      	// const freeShippingThreshold = 75;
		const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
		const cartTotalInCurrency = cartTotal / 100;
		const currencyRate = Shopify?.currency?.rate ? Number(Shopify.currency.rate) : 1;
		const thresholdInCurrency = Math.round(freeShippingThreshold * currencyRate);

		const remainingAmount = thresholdInCurrency - cartTotalInCurrency;
		const remainingCents = remainingAmount * 100;
		const progress = Math.min(100, (cartTotalInCurrency / thresholdInCurrency) * 100);

		let shippingMessage = '';
		let shippingSuccess = false;

		if (remainingAmount > 0) {
		//   shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free
		// 	.replace('', this._formatMoney(remainingCents, KROWN.settings.shop_money_format));
			shippingMessage = "Spare 6€ bei Versand- und Servicegebühren – schon ab einem Bestellwert von "+freeShippingThreshold+"€ bei Lieferungen nach Deutschland. <span style='opacity:.62'><a style='text-decoration: underline;' href='/pages/produktion-zahlung-versand'>Klick hier</a> und erfahre mehr über Versand & Produktion.</span>";
		} else {
			shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
			shippingSuccess = true;
		}

      if ( this.hasAttribute('data-show-alert') ) {
		const deliveryIcon = `
		<svg width="25px" height="25px" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
			<defs>
			<style>
				.cls-1 {
				fill-rule: evenodd;
				}
			</style>
			</defs>
			<path class="cls-1" d="M23.05,26.98c-2.16,0-3.93-1.76-3.93-3.93v-.1h-8.25v.1c0,2.16-1.76,3.93-3.93,3.93s-3.93-1.76-3.93-3.93v-.1H.91c-.5,0-.91-.41-.91-.91s.41-.91.91-.91h2.56c.79-1.26,2.09-2.01,3.48-2.01s2.69.75,3.4,1.96l5.76.05V5.94c0-.61-.5-1.11-1.11-1.11H.91c-.5,0-.91-.41-.91-.91s.41-.91.91-.91h14.09c1.61,0,2.92,1.31,2.92,2.92v2.11h5.99c.97,0,1.92.39,2.61,1.08l2.39,2.39c.7.7,1.08,1.63,1.08,2.61v5.89c0,1.57-1.28,2.88-2.85,2.92h-.1s-.08.1-.08.1c0,2.16-1.76,3.93-3.93,3.93ZM23.05,20.94c-1.17,0-2.11.95-2.11,2.11s.95,2.11,2.11,2.11,2.11-.95,2.11-2.11-.95-2.11-2.11-2.11ZM6.95,20.94c-1.17,0-2.11.95-2.11,2.11s.95,2.11,2.11,2.11,2.11-.95,2.11-2.11-.95-2.11-2.11-2.11ZM23.05,19.13c1.39,0,2.69.75,3.4,1.96l.62.05c.62,0,1.12-.5,1.12-1.11v-4.13h-5.11c-1.07,0-1.93-.87-1.93-1.93v-4.11h-3.22v11.28h1.65c.79-1.26,2.09-2.01,3.48-2.01ZM22.95,14.07l.12.02h5.11v-.11c-.05-.45-.24-.87-.54-1.17l-2.39-2.39c-.35-.36-.83-.55-1.33-.55h-.96v4.21ZM8.96,8.86c.5,0,.91-.41.91-.91s-.41-.91-.91-.91H1.71c-.5,0-.91.41-.91.91s.41.91.91.91h7.25ZM12.99,12.89c.5,0,.91-.41.91-.91s-.41-.91-.91-.91H4.93c-.5,0-.91.41-.91.91s.41.91.91.91h8.05ZM8.96,16.91c.5,0,.91-.41.91-.91s-.41-.91-.91-.91H.91c-.5,0-.91.41-.91.91s.41.91.91.91h8.05Z"/>
		</svg>
		`;
        this.innerHTML = `
          <div class="free-shipping-banner ${shippingSuccess ? 'success' : ''}">
			<div class="icon-container">${deliveryIcon}</div>
			<div class="progress-content">
			  <div class="progress-bar">
				<div class="progress-fill" style="width: ${progress}%;"></div>
			  </div>
			  <p class="text-size--small">${shippingMessage}</p>
			</div>
		  </div>`;
      } else {
        this.innerHTML = shippingMessage;
      }

    }

    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}

			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';

				if (isNaN(number) || number === null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';

				return dollarsAmount + centsAmount;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);

		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
